import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Lock, LogIn } from 'lucide-react';
import { toast } from 'sonner';
import { adminLogin, verifyAdminToken, getAdminToken } from '../lib/adminAuth';

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      if (getAdminToken()) {
        const ok = await verifyAdminToken();
        if (ok) navigate('/admin', { replace: true });
      }
    })();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password) return;
    try {
      setLoading(true);
      await adminLogin(password);
      toast.success('Welcome back, Chanah');
      navigate('/admin', { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page" data-testid="admin-login-page">
      <div className="admin-login-card">
        <div className="admin-login-icon">
          <Lock size={28} />
        </div>
        <h1 className="heading-1">Admin Access</h1>
        <p className="body-medium" style={{ color: 'var(--text-secondary)', marginBottom: 24 }}>
          Enter the admin password to manage Momshiach submissions.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoFocus
              data-testid="admin-password-input"
            />
          </div>
          <button
            type="submit"
            className="btn-primary"
            style={{ width: '100%' }}
            disabled={loading || !password}
            data-testid="admin-login-btn"
          >
            <LogIn size={18} />
            <span>{loading ? 'Signing in…' : 'Sign In'}</span>
          </button>
        </form>
        <p style={{ marginTop: 24, textAlign: 'center' }}>
          <Link to="/" className="nav-link" data-testid="admin-back-home">← Back to site</Link>
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
